/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const AccountListPage = lazyLoad(
  () => import('./index'),
  module => module.AccountListPage
);
